<template>
	<span>
		<span v-if="!readMoreActivated">{{ isLongText ? text.slice(0, 150) + "..." : text }}</span>
		<span class="readmore clickarea" v-if="!readMoreActivated && isLongText" @click="activateReadMore()">
			{{ $t("global.show_all") }}
		</span>
		<span v-if="readMoreActivated" v-html="text"></span>
		<span class="readmore clickarea" v-if="readMoreActivated && isLongText" @click="deactivateReadMore()">
			{{ $t("global.reduce") }}
		</span>
	</span>
</template>
<script>
export default {
	data: () => ({
		readMoreActivated: false,
	}),
	props: {
		text: "",
	},
	computed: {
		isLongText() {
			if (this.text) {
				if (this.text.length > 150) {
					return true;
				}
			}
			return false;
		},
	},
	methods: {
		activateReadMore() {
			this.readMoreActivated = true;
		},
		deactivateReadMore() {
			this.readMoreActivated = false;
		},
	},
};
</script>
